import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CollectionLight')
export class CollectionLight {

  @JsonProperty('collection_id', Number)
  collectionId: number = 0;

  @JsonProperty('name', String)
  name: string = '';
}
